const TestimonialsPageStyles = {
    pageContainer: {
      padding: '2rem',
      textAlign: 'center',
    },
    pageTitle: {
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    pageSubtitle: {
      marginBottom: '2rem',
      color: 'gray',
    },
    cardContainer: {
      justifyContent: 'center',
    },
    card: {
      padding: '1.5rem',
      textAlign: 'center',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    avatarContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '1rem',
    },
    avatar: {
      width: 64,
      height: 64,
    },
    testimonialText: {
      fontStyle: 'italic',
      marginBottom: '1rem',
      color: 'gray',
    },
    clientName: {
      fontWeight: 'bold',
    },
  };
  
  export default TestimonialsPageStyles;
  